import * as React from "react";
import styled from "../../../styled/index";
import { FaChevronRight } from "react-icons/fa";
import { ModalTitle } from "./content";
import { SelectModal } from "../../form/select.modal/index";
const Wrapper = styled("div") `
  .content {
    border-bottom: 1px solid ${(props) => props.theme.box.border};
  }
`;
const Icon = styled("div") `
  font-size: 16px;
`;
export class ModalSelectSection extends React.Component {
    constructor(props) {
        super(props);
        this.titleClick = () => {
            this.setState({ active: !this.state.active });
        };
        this.state = { active: false };
    }
    render() {
        const { active } = this.state;
        const props = this.props;
        return (React.createElement(Wrapper, null,
            React.createElement(ModalTitle, { className: "cursor", level: props.level, onClick: this.titleClick, paddinglr: props.paddinglr, paddingtb: props.paddingtb },
                props.title,
                React.createElement(Icon, null,
                    React.createElement(FaChevronRight, null))),
            (!!props.selected) && props.children,
            React.createElement(SelectModal, { innerId: `${props.id}-select-modal`, title: props.selectTitle, level: 2, width: 380, active: active, onSelect: (o) => {
                    props.onSelect(o);
                    this.setState({ active: false });
                }, close: () => this.setState({ active: false }), options: props.options })));
    }
}
//# sourceMappingURL=select-section.js.map